<template>
<transition name="fade">
    <div class="content-wrapper full-page-wrapper auth-pages login-2" style="background:#f8f8f8">
        <div class="row h-100">
       <!-- <particles-bg type="random" :bg="true" /> -->
            <div class="col-lg-4 carouselPanel d-none d-sm-none d-md-block text-center pt-3" >
                <!--  <img :src="'/images/background/'+baner+'.png'" alt="Slide1" width="600px"><br> -->
            </div>
            <div class="col-lg-4 carouselPanel loginPanel ">
                <div class="card">
                        <div class="card-body px-5 py-5">
                        <!--      <div class="text-uppercase" style="background: #29B3A6;color:#fff;padding:15px 10px 2px 10px;text-align:center;border-radius:20px">
                        <h6 v-if="baner===3">Vos informations sont 100% sécurisées et confidentielles</h6>
                        <h6 v-if="baner===2">Gérer vos opérations depuis une plateforme simple d’utilisation</h6>
                        <h6 v-if="baner===1">Payez, Recevez et envoyez de l’argent partout et à tout moment !</h6>
                    </div> -->
                        <h5 style="color: #fff" class="mt-4">Réinitialisation de votre mot de passe</h5>
                        <p style="color: #fff">Veuillez définir un nouveau mot de passe pour votre compte utilisateur.</p>
                           <v-alert  style="text-align: center;" v-show="errors.reset" dense outlined :type="state">{{$t(errors.reset)}}</v-alert>
                            <div style="text-align: center" v-if="submitting"><img style="width: 15%" alt="loader" src="../../../public/loaders/loader_turq.gif"/></div>

                            <form class="row" >
                                <div class="form-group col-ms-12 col-lg-12">
                                    <input type="password"  class="form-control p_input" v-model="password" placeholder="Nouveau mot de passe">
                                </div>
                                <div class="form-group col-ms-12 col-lg-12">
                                    <input type="password"  class="form-control p_input" v-model="password_confirmation" placeholder="Confirmer mot de passe">
                                </div>
                                <div class="text-center col-lg-12 col-xs-12">
                                    <button @click.prevent="submitForm" type="submit" class="btn btn-primary btn-md enter-btn">Réinitialisé</button>
                                </div>

                                <div class="form-group col-lg-12 col-xs-12  text-center loginBottom">
                                    <span class="text-center"> <router-link to="/register" class="connect-btn" style="color: white!important;"> Je souhaite  me conecter</router-link></span>
                                </div>
<div class="col-12 text-center mb-0 pb-0">
                        <img src="/images/logo_large_white.png" alt="intram_logo" width="70px">
                    </div>
                            </form>
                        </div>
                        </div>
                    </div>
    </div>
    </div>
</transition>
</template>

<script>
    import {mapState} from "vuex";
    import helpers from "@/mixins/helpers";

    export default {
      name: "PasswordForget",
      mixins:[helpers(this)],
      data(){
          return {
                baner:(Math.floor(Math.random() * 3) + 1),
              password :undefined,
              password_confirmation :undefined,
              errors:{},
              state:'',
              submitting:false,
          }
        },
      computed:{
        ...mapState('generalsettings/',['generals']),

      },
        methods:{
            checkisDashboard(){
                this.$emit('checkisDashboard',false);
            },
            submitForm(){
                let VueBox = this;
                if (VueBox.password===undefined){
                    VueBox.state = 'error';
                    VueBox.errors.reset =  VueBox.$t('password_required');
                    VueBox.$forceUpdate();
                    return;
                }else if (VueBox.password_confirmation===undefined) {
                    VueBox.state = 'error';
                    VueBox.errors.reset =  VueBox.$t('password_confirmation_required');
                    VueBox.$forceUpdate();
                    return;
                }else if(VueBox.password_confirmation !== VueBox.password){
                    VueBox.state = 'error';
                    VueBox.errors.reset =  VueBox.$t('password_mismatch');
                    VueBox.$forceUpdate();
                    return;
                }else if(VueBox.password_confirmation.length <this.getSetting('nmcpw') || VueBox.password.length<this.getSetting('nmcpw')){
                  VueBox.state = 'error';
                  VueBox.errors.reset =  VueBox.$t('min_8_caracters',{number:this.getSetting('nmcpw')});
                  VueBox.$forceUpdate();
                  return;
                }
                VueBox.submitting = true;
                let formData = new FormData();
                formData.append('password',this.password);
                let routeData ={
                    id:this.$route.params.id,
                    token:this.$route.params.token
                };
                let data = {route:routeData,form : formData};
                VueBox.$store.dispatch("auth/resetPassword",data).then(response =>{
                    window.console.log(response);
                    if (response.error){
                        VueBox.submitting = false;
                        VueBox.state=(response.error)?'error':'success';
                        VueBox.errors.reset = response.message;
                        VueBox.$forceUpdate();
                    }else{
                        window.location = window.origin+"/login"
                    }

                });
            },
        },
        created() {
            this.checkisDashboard();
        }
    }
</script>

<style scoped>
   .auth-pages button{
        font-size: 1rem;
    }
    .forgot-pass, .hed{
       color: #fff !important;     
    }
    .auth-pages .form-group{
        margin-bottom: 5px !important;
    }
    .model-input{
        padding: 0 90px !important;
    }
    .submit_panel{
        padding: 5px;
        font-weight: 500;
        font-size: 10pt;
         color: rgb(31, 23, 23);
        text-transform: uppercase;
    }
    .redirection_panel{
        padding: 5px;
        font-weight: 500;
        font-size: 9pt;
        color: rgb(31, 23, 23);
        text-transform: uppercase;
        border-radius: 6px;
    }
    #countries{
        color: #0D0A0A !important;
    }
    .connect-btn{
        color: #fff;
        font-weight: 500;
        text-decoration: underline;
    }
    .loginPanel .card{
        max-height: 100vh !important;
        overflow-y: auto;
        margin-top: auto;
margin-bottom: auto;
border-bottom: 5px solid #29B3A6;
        /* background-image: linear-gradient(#f8f8f8, #29B3A6); */
    background: #29B3A6;

    }
    .loginPanel{
        padding: 20px!important;
        min-height: 100vh;
        display: flex;
  align-items: center;
    }
    .requiredCheck{
        color: red;
    }
    .loginBottom{
        font-size: 12pt;
    }

    #loginCarousel{
        max-height: 100vh;
    }

    .carousel-inner{
        height: 100%;
    }
    .carousel-inner{
        background-size: cover;
        text-align: center;
    }
    .qrPanel{
        color:#fff;
        position: absolute;
        bottom: 70px;
        left: 17vw;
        width: 350px;
        padding: 20px;
        background: rgba(16, 70, 65, 0.8);
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
        border-radius: 23px;
        font-size: 11pt;
        font-weight: bold;
    }
    .qrPanel img{
        width: 250px !important;
    }

    .qrPanel span{
        padding: 20px;
        margin-top: 20px;
        font-size: 11pt;
        font-weight: bold;
        text-transform: uppercase;
        color: #fff;
    }
   
    .carouselPanel{
        padding: 0;
    }
    .card-image{width: 250px}
    .auth-pages .form-group .form-control{border-radius: 6px;height: 40px;border: 1px solid rgba(0, 0, 0, 0.15);}
    .wrapper{
        margin-top: 20px;
        margin-bottom: 50px;
    }
    .background-3 {
        /*box-shadow: inset 0 0 100px hsla(0,0%,0%,.3);*/
    }
     .form-label{
        font-size: 12pt;
        font-weight: 500;
        color: #fff;
    }
   
   
    .auth-pages .form-group .form-control:focus{
        transition-duration: 5ms;
        border: 1px solid rgba(41, 179, 166, 1);
    }
    .auth-pages .form-group .form-control:hover{
        border: 1px solid rgba(41, 179, 166, 1);
        transition-duration: 5ms;
    }
.auth-pages.login-2 .card{
    min-height: unset;
}
    @media (max-width: 991px) {
        .model-input{
            padding: 0 25px !important;
        }
    }
    .carousel-item img{
        width: 100%;
    }
    .carousel-indicators li{
        color:#373737
    }
</style>
